import { useTestarCanal } from "../../lib/config-alertas/hooks";
import { useTemPermissao } from "../../lib/auth/permissoes";

/*
 * Botão "Testar" de um canal (FE-6a — Tela 6).
 *
 * Dispara `POST /api/canais/{id}/testar` via `useTestarCanal`. A ação é GATED pela
 * permissão DEDICADA `testar_canal` (gate SEPARADO de `configurar_alertas`): sem
 * ela, o botão NÃO é renderizado (o backend devolveria 403 de qualquer forma).
 *
 * Estados: idle → testando ("Testando…", disabled) → ok ✓ (`text-sucesso` "Canal
 * OK") / erro ✗ (`text-erro` + a mensagem CATEGÓRICA `erro` do backend). Falha de
 * entrega vem 200 com `ok:false` (não erro HTTP); falha de TRANSPORTE/permissão
 * vem como rejeição (`isError`) → mensagem genérica.
 *
 * 🔴 NUNCA exibe `detalhe` (pode conter dado sensível de diagnóstico) — só o `erro`
 * categórico, que o backend já saneou.
 */

const ACAO_TESTAR_CANAL = "testar_canal";

interface BotaoTestarProps {
  canalId: string;
}

export function BotaoTestar({ canalId }: BotaoTestarProps): JSX.Element | null {
  const podeTestar = useTemPermissao(ACAO_TESTAR_CANAL);
  const testar = useTestarCanal();

  // Gate por permissão dedicada: sem `testar_canal`, o botão nem aparece.
  if (!podeTestar) {
    return null;
  }

  function aoClicar(): void {
    testar.mutate(canalId);
  }

  return (
    <span className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={aoClicar}
        disabled={testar.isPending}
        className="text-flame hover:underline disabled:opacity-60"
      >
        {testar.isPending ? "Testando…" : "Testar"}
      </button>

      {testar.isSuccess && testar.data.ok && (
        <span role="status" className="text-sucesso">
          ✓ Canal OK
        </span>
      )}

      {testar.isSuccess && !testar.data.ok && (
        <span role="status" className="text-erro">
          ✗ {testar.data.erro ?? "Falha no teste do canal."}
        </span>
      )}

      {testar.isError && (
        <span role="status" className="text-erro">
          ✗ Não foi possível testar o canal.
        </span>
      )}
    </span>
  );
}
